<template>
  <VView class="prizes" back-button-to="/menu" header="Nagrody">
    <VMedia class="prizes__prizes">
      <img src="@/assets/prizes.png" />
    </VMedia>

    <VButtonGroup>
      <!-- <VButton alternative to="/contest">Weź udział!</VButton> -->
      <VButton alternative to="/contest">Laureaci</VButton>
    </VButtonGroup>
  </VView>
</template>

<script>
import VView from '@/components/VView.vue';
import VBox from '@/components/VBox.vue';
import VMedia from '@/components/VMedia.vue';
import VButton from '@/components/VButton.vue';
import VButtonGroup from '@/components/VButtonGroup.vue';

export default {
  name: 'Prizes',
  components: {
    VView,
    VBox,
    VMedia,
    VButton,
    VButtonGroup,
  },
};
</script>

<style lang="scss">
.prizes {
  &__prizes {
    max-width: 800px;
    margin: 0 auto;
  }

  &__buttons {
    margin-top: 40px !important;
  }

  ::v-deep .button-group {
    margin-top: 100px !important;
  }
}
</style>
